export const environment = {
  production: false,
  // apiUrl: 'https://tq462tl1-5002.inc1.devtunnels.ms',
  // apiUrl: 'https://gpqlv18n-5002.inc1.devtunnels.ms',
  apiUrl: 'https://recruitai-backend.buckleconsult.com',
  stripePublishableKey: 'pk_test_51TIB1xPMthXMvbrgM8RSiCrFAbn0ywVdNqs5mIuE6kyfmdJrzQb8OMLJ5dLtwNKTftMJouIPt9VlvDbDRv2ZcQwI00hHqyU5mM'
};
